import React, {useEffect, useMemo} from 'react';
import useSearchParams from './components/hooks/useSearchParams';
import ShowocaseLayout from '../../../components/layout/ShowocaseLayout';
import Loadable from '../../../components/loadable';
import useStrapi from './components/hooks/useStrapi';
import demostoreUtils from '../../../utils/demostoreUtils';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import DefaultErrorLayout from '../../../components/layout/DefaultErrorLayout';
import NotFoundAsync from '../../notfound/async';

export default props => {
  const {...rest} = props;
  const {debug} = useSearchParams();
  const {strapiResponse} = useStrapi(demostoreUtils.getStrapiKey('content'));
  const demostoreFeature = _get(
    strapiResponse,
    'content.demoStoreFeature.demoStoreFeature'
  );
  const {pagePath, autoLoadWebSdk, ...pageProps} = useMemo(
    () => demostoreUtils.getFeaturePage(demostoreFeature),
    [demostoreFeature]
  );

  useEffect(() => {
    if (!debug) {
      return;
    }
    console.log('[content debug]', {
      demostoreFeature,
      pagePath,
      autoLoadWebSdk,
      pageProps,
    });
  }, [debug, demostoreFeature, pagePath, autoLoadWebSdk, pageProps]);

  useEffect(() => {
    window.demostoreFeatureKey = _get(pageProps, 'featureKey');
    return () => {
      window.demostoreFeatureKey = '';
    };
  }, [pageProps]);

  const LoadedComponent = useMemo(
    () => (pagePath ? Loadable(() => import(`${pagePath}`)) : null),
    [pagePath]
  );

  if (!strapiResponse.loaded) {
    return null;
  }

  if (_isEmpty(_get(strapiResponse, 'content'))) {
    return <DefaultErrorLayout {...rest} component={NotFoundAsync} />;
  }

  return (
    <ShowocaseLayout
      {...rest}
      demostoreFeature={demostoreFeature}
      autoLoadWebSdk={autoLoadWebSdk}
      component={LoadedComponent}
      componentProps={{
        strapiResponse,
        ...pageProps,
      }}
    />
  );
};
